import { IconButton, Paper } from "@mui/material";
import { activateEnvSwitch } from "core/model/utils/featureFlags";
import { isPrintMode } from "core/model/utils/urls";
import { HorizontalLayout, VerticalLayout } from "ds_legacy/materials/layouts";
import { Z_INDEX_APP_BAR, dp, padding } from "ds_legacy/materials/metrics";
import { FONT_SIZE_16 } from "ds_legacy/materials/typography";
import BlinkingEnv from "dsl/atoms/BlinkingEnv";
import { EnvSelect } from "dsl/atoms/EnvSelect";
import { useMedia } from "dsl/atoms/ResponsiveMedia";
import { XIcon } from "lucide-react";
import { useState } from "react";

export const ProviderSearchEnvSwitch = () => {
  const [show, setShow] = useState(false);
  const { isMobile, isTablet } = useMedia();
  const isPrint = isPrintMode();

  if (!activateEnvSwitch || isPrint) return null;

  return (
    <Paper
      sx={{
        "@media print": {
          display: "none",
        },
        bottom: isMobile ? 20 : undefined,
        position: "fixed",
        right: isMobile ? 20 : isTablet ? "28vw" : "50vw",
        top: isMobile ? undefined : 20,
        zIndex: Z_INDEX_APP_BAR + 1,
      }}
    >
      <HorizontalLayout>
        {show && (
          <div style={{ padding: padding(2) }}>
            <EnvSelect
              style={{ width: dp(200) }}
              onChange={() => {
                window.location.reload();
              }}
            />
          </div>
        )}
        <VerticalLayout justify={isMobile ? "flex-end" : "flex-start"}>
          <IconButton onClick={() => setShow((s) => !s)}>
            {show ? <XIcon size={FONT_SIZE_16} /> : <BlinkingEnv />}
          </IconButton>
        </VerticalLayout>
      </HorizontalLayout>
    </Paper>
  );
};
